import React from 'react';
import { ScanLine, Cpu, Zap, Settings, Gauge, Cable, Droplet } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';
import { services, businessInfo } from '../mock';
import { useTranslation, Trans } from 'react-i18next';

const iconMap = {
  scan: ScanLine,
  cpu: Cpu,
  zap: Zap,
  settings: Settings,
  gauge: Gauge,
  cable: Cable,
  droplet: Droplet
};

export const Services = () => {
  const { t } = useTranslation();
  return (
    <section id="services" className="py-24 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white mb-4">
           <Trans i18nKey="services_title">
              Our <span className="text-lime-400">Services</span>
            </Trans>
          </h2>
          <p className="text-xl text-neutral-300 max-w-2xl mx-auto">
              {t('services_subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="bg-neutral-800 border-neutral-700 hover:border-lime-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-lime-500/10 hover:-translate-y-1 group"
              >
                <CardHeader className="space-y-4">
                  <div className="w-14 h-14 bg-lime-500/10 rounded-lg flex items-center justify-center group-hover:bg-lime-500/20 transition-colors duration-300">
                    <Icon className="h-7 w-7 text-lime-400" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-white group-hover:text-lime-400 transition-colors duration-300">
                    {t(service.title)}
                  </CardTitle>
                  <CardDescription className="text-neutral-300 text-base leading-relaxed">
                    {t(service.description)}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-neutral-300 text-lg mb-6">
            {t('services_footer')}
          </p>
          <a
            href={`https://wa.me/${businessInfo.whatsapp.replace(/\D/g, '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center flex-col bg-transparent border-2 border-lime-500 text-lime-400 hover:bg-lime-500 hover:text-neutral-900 font-bold px-8 py-3 rounded-lg transition-all duration-300 "
          >
            {t("services_cta")}
            <svg className="h-5 w-5 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform " fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
            
          </a>
        </div>
      </div>
    </section>
  );
};
